module.exports = __webpack_public_path__ + "img/selected0-min.cbc6d6f1.png";